function scrollTo(element, offsetElem = 100) {
  let bodyRect = document.body.getBoundingClientRect();
  let elemRect = element.getBoundingClientRect();
  let offset = elemRect.top - bodyRect.top;
  window.scroll({
    behavior: "smooth",
    left: 0,
    top: offset - offsetElem - 40,
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll(".scroll-to-video").length > 0) {
    document.querySelectorAll(".scroll-to-video").forEach((element) => {
      element.addEventListener("click", function () {
        if (element.getAttribute("id") === "playButtonOverlay" && window.scrollY < 200) {
          if (window.innerWidth < 1930) {
            scrollTo(document.getElementById("slide1"), 350);
          } else {
            scrollTo(document.getElementById("slide1"), 1000);
          }
        } else if (element.dataset.aftervideo) {
          scrollTo(document.getElementById("videoCircle"), -350);
        } else if (!(element.getAttribute("id") == "playButtonOverlay")) {
          if (window.innerWidth < 1930) {
            scrollTo(document.getElementById("slide1"), 130);
          } else {
            scrollTo(document.getElementById("slide1"), 1000);
          }
        }
      });
    });
  }

  /*
   ** Scroll anchors
   */

  if (document.querySelectorAll('a[href^="#"]').length > 0) {
    let anchors = document.querySelectorAll('a[href^="#"]');
    for (const anchor of anchors) {
      if (anchor.getAttribute("href").match(/#[a-zA-Z0-9]/)) {
        anchor.addEventListener("click", (e) => {
          let height = 0;
          if (document.querySelectorAll("header").length > 0) {
            height = document.querySelector("header").offsetHeight;
          }
          e.preventDefault();
          scrollTo(document.getElementById(anchor.getAttribute("href").replace("#", "")), height);
        });
      }
    }
  }

  // Calulate height of element with js-height-calculation class
  if (document.querySelectorAll(".js-height-calculation").length > 0) {
    let elements = document.querySelectorAll(".js-height-calculation");
    for (const element of elements) element.parentElement.style.height = element.scrollHeight + "px";
  }

  /*
   * AUDIO
   */

  if (document.querySelectorAll(".js-audio").length > 0) {
    // const countdownTimer = document.querySelector('.js-duration');

    if (document.querySelectorAll(".js-play-audio").length > 0) {
      // let playAudio = document.querySelector('.js-play-audio');
      let playAudios = document.querySelectorAll(".js-play-audio");
      for (const playAudio of playAudios) {
        playAudio.addEventListener("click", (e) => {
          e.preventDefault();
          document.querySelector(".js-pause-audio.js-index-" + playAudio.dataset.index).classList.remove("d-none");
          document.querySelector(".js-play-audio.js-index-" + playAudio.dataset.index).classList.add("d-none");
          document.querySelector(".svg-audio.js-index-" + playAudio.dataset.index).classList.add("played");
          document.querySelector(playAudio.dataset.player).play();
          // audioPlayer.play();
        });

        document.querySelector(playAudio.dataset.player).addEventListener("ended", () => {
          // countdownTimer.textContent = formatAudioLength(0);
          document.querySelector(".svg-audio.js-index-" + playAudio.dataset.index).classList.remove("played");
          document.querySelector(".js-pause-audio.js-index-" + playAudio.dataset.index).classList.add("d-none");
          document.querySelector(".js-play-audio.js-index-" + playAudio.dataset.index).classList.remove("d-none");
        });
      }
    }

    if (document.querySelectorAll(".js-pause-audio").length > 0) {
      // let pauseAudio = document.querySelector('.js-pause-audio');
      let pauseAudios = document.querySelectorAll(".js-pause-audio");
      for (const pauseAudio of pauseAudios) {
        pauseAudio.addEventListener("click", (e) => {
          e.preventDefault();
          document.querySelector(".js-pause-audio.js-index-" + pauseAudio.dataset.index).classList.add("d-none");
          document.querySelector(".js-play-audio.js-index-" + pauseAudio.dataset.index).classList.remove("d-none");
          document.querySelector(".svg-audio.js-index-" + pauseAudio.dataset.index).classList.remove("played");
          document.querySelector(pauseAudio.dataset.player).pause();
        });
      }
    }
  }

  if (document.querySelectorAll(".lightgallery").length > 0) {
    let galleries = document.querySelectorAll(".lightgallery");

    for (const gallery of galleries) {
      lightGallery(gallery, {
        licenseKey: "8CAA63FC-B4904F57-8FFDCD7B-AD332B1A",
        mobileSettings: {
          controls: true,
          showCloseIcon: true,
          download: false,
        },
      });
    }
  }

  if (document.querySelectorAll(".lightgallery-video").length > 0) {
    let galleriesVideo = document.querySelectorAll(".lightgallery-video");

    for (const gallery of galleriesVideo) {
      lightGallery(gallery, {
        licenseKey: "8CAA63FC-B4904F57-8FFDCD7B-AD332B1A",
        plugins: [lgVideo],
        getCaptionFromTitleOrAlt: false,
        youtubePlayerParams: {
          modestbranding: 1,
          showinfo: 0,
          rel: 0,
          controls: 1,
        },
        videojs: true,
        videojsOptions: {
          muted: false,
        },
        mobileSettings: {
          controls: true,
          showCloseIcon: true,
          download: false,
        },
      });
    }
  }

  if (document.querySelectorAll(".share-btn").length > 0) {
    let openModals = document.querySelectorAll(".share-btn");
    for (let openModal of openModals) {
      openModal.addEventListener("click", (e) => {
        e.preventDefault();
        let element = document.getElementById("modalShare");
        element.classList.add("open");
        document.querySelector("#modalShare .js-close-modal-share").focus();
      });
    }
  }

  if (document.querySelectorAll(".js-close-modal-share").length > 0) {
    let closeModals = document.querySelectorAll(".js-close-modal-share");
    for (let closeModal of closeModals) {
      closeModal.addEventListener("click", (e) => {
        e.preventDefault();
        let element = document.getElementById("modalShare");
        element.classList.remove("open");
        document.querySelector(".share-btn").focus();
      });
    }
  }

  if (document.querySelectorAll(".js-animated-words").length > 0) {
    let animatedWords = document.querySelectorAll(".js-animated-words");
    for (const animatedWord of animatedWords) {
      const words = animatedWord.dataset.words.split(",");

      const animatedWordContainer = document.createElement("span");
      animatedWordContainer.classList.add("animated-word-container");
      const animatedWordContainerInner = document.createElement("span");
      animatedWordContainerInner.classList.add("animated-word-container-inner");
      animatedWordContainer.appendChild(animatedWordContainerInner);
      animatedWordContainerInner.innerHTML = words.map((word) => `<span class="animated-word">${word}</span>`).join(" ");
      animatedWord.innerHTML = animatedWord.innerHTML.replace("[listing]", animatedWordContainer.outerHTML);
    }
  }
});

// let targetY = window.scrollY;
// let currentY = targetY;
// let isAnimating = false;
// const lerpFactor = 0.1; // Facteur d'interpolation pour la fluidité (0.05 à 0.2)
// const scrollSensitivity = 0.5; // Sensibilité de la molette

// window.addEventListener(
//   "wheel",
//   (e) => {
//     e.preventDefault(); // Empêche le défilement par défaut

//     // Mettre à jour la position cible
//     targetY = Math.max(0, targetY + e.deltaY * scrollSensitivity);

//     if (!isAnimating) {
//       isAnimating = true;
//       smoothScroll();
//     }
//   },
//   { passive: false }
// );

// function smoothScroll() {
//   // Interpolation linéaire pour approcher la cible
//   currentY += (targetY - currentY) * lerpFactor;

//   // Arrêter si assez proche
//   if (Math.abs(currentY - targetY) < 0.1) {
//     window.scrollTo(0, targetY);
//     isAnimating = false;
//     return;
//   }

//   window.scrollTo(0, currentY);

//   // Continuer l'animation
//   requestAnimationFrame(smoothScroll);
// }
